<template>
  <div>
    <div class="viewMods lgrid-noGutter">
      <button
        v-for="(viewModId, key) in enabledButtons"
        :key="key"
        class="no-button lgrid-middle-noWrap"
        :class="[viewModId, viewModId == currentMod ? 'active': '']"
        @click="currentMod = viewModId"
        v-html="t.viewMods[viewModId]"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'DsioMods',
  props: {
    viewMods: {
      type: Array,
      default: () => [],
    },
    defaultViewMod: {
      type: String,
      default: 'mixte',
    },
  },
  computed: {
    /**
     * retourne mes boutons valides
     * si plus de 2 boutons on retourne tout
     * @returns {default.props.viewMods|{default, type}}
     */
    enabledButtons () {
      if (this.isMobileScreen && this.viewMods.length > 2) {
        return this.viewMods.filter(mod => mod !== 'mixte' && mod !== this.currentMod);
      }

      return this.viewMods.length > 2 ? this.viewMods : this.viewMods.filter(mod => mod !== this.currentMod);
    },
    currentMod: {
      get () {
        return this.viewMod;
      },
      set (name) {
        if (this.isMultiApp) {
          return this.dispatchAll('updateMod', name);
        }
        return this.dispatch('updateMod', name);
      },
    },
  },
  beforeCreated () {
    this.currentMod = this.defaultViewMod;
  },
};
</script>
